import { requireModule } from 'auth/guards';
import { MODULES } from 'auth/permissions';
import CandidateDetails from './candidates/pages/CandidateDetails';
import CandidatesPage from './candidates/pages/Candidates';
import HiringRequestForm from './hiring-requests/components/HiringRequestForm';
import JobPostingDetails from './hiring-requests/components/JobPostingDetails';
import HiringRequestsPage from './hiring-requests/pages/HiringRequests';
import InterviewFlow from './interview/admin/pages/InterviewFlow';
import CandidateDataEntry from './interview/candidates/pages/CandidateDataEntry';
import OfferAcceptRejectPage from './interview/candidates/pages/OfferAcceptReject';

export const protectedHiringRoutes = [
  {
    path: '/hiring-request',
    loader: requireModule(MODULES.RECRUITMENT),
    element: <HiringRequestsPage />,
    children: [
      { path: 'new', element: <HiringRequestForm /> },
      { path: ':jobPostingId', element: <JobPostingDetails /> },
    ],
  },
  {
    path: '/candidates',
    loader: requireModule(MODULES.CANDIDATES),
    element: <CandidatesPage />,
    children: [{ path: ':applicationId', element: <CandidateDetails /> }],
  },
  {
    path: '/candidates/:applicationId',
    loader: requireModule(MODULES.CANDIDATES),
    handle: { breadcrumb: () => 'Approved Candidates' },
    children: [
      {
        path: 'interview',
        element: <InterviewFlow />,
        handle: { breadcrumb: () => 'Interview Rounds' },
      },
    ],
  },
];

export const publicHiringRoutes = [
  { path: '/offer/:applicationId', element: <OfferAcceptRejectPage /> },
  { path: '/data-entry/:applicationId', element: <CandidateDataEntry /> },
];
